import React from 'react';
import { ShortcutContext } from '../ShortcutProvider/ShortcutProvider.mjs';

const DEFAULT_IGNORED_TAGS = ['INPUT', 'SELECT', 'TEXTAREA'];
function useShortcut(ordered, onMatch, options = {}) {
  const shortcutManager = React.useContext(ShortcutContext);
  const subscription = React.useRef(null);
  const {
    node,
    held,
    ignoreInput,
    acceptedDefaultIgnoredTags,
    allowDefault
  } = options;
  React.useEffect(() => {
    if (shortcutManager == null) {
      return;
    }

    subscription.current = shortcutManager.subscribe({
      onMatch,
      ordered,
      node,
      held,
      ignoreInput: ignoreInput || false,
      ignoredTags: getIgnoredTags(acceptedDefaultIgnoredTags),
      allowDefault: allowDefault || false
    });
    return () => {
      if (subscription.current == null) {
        return;
      }

      subscription.current.unsubscribe();
    };
  }, [node, ordered, held, ignoreInput, acceptedDefaultIgnoredTags, allowDefault, shortcutManager, onMatch]);
}

function getIgnoredTags(acceptedDefaultIgnoredTags) {
  if (!(acceptedDefaultIgnoredTags !== null && acceptedDefaultIgnoredTags !== void 0 && acceptedDefaultIgnoredTags.length)) {
    return DEFAULT_IGNORED_TAGS;
  }

  return DEFAULT_IGNORED_TAGS.filter(tag => !acceptedDefaultIgnoredTags.includes(tag));
}

export { useShortcut as default };
